import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const Table = /*#__PURE__*/ React.forwardRef(({ className, containerClassName, containerProps, containerRef, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ...containerProps,
        className: cn('relative w-full overflow-auto', containerClassName),
        ref: containerRef,
        children: /*#__PURE__*/ _jsx("table", {
            ref: ref,
            className: cn('w-full caption-bottom text-sm', className),
            ...props
        })
    }));
Table.displayName = 'Table';
const TableHeader = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("thead", {
        ref: ref,
        className: cn('[&_tr]:border-b', className),
        ...props
    }));
TableHeader.displayName = 'TableHeader';
const TableBody = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tbody", {
        ref: ref,
        className: cn('[&_tr:last-child]:border-0', className),
        ...props
    }));
TableBody.displayName = 'TableBody';
const TableFooter = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tfoot", {
        ref: ref,
        className: cn('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className),
        ...props
    }));
TableFooter.displayName = 'TableFooter';
const TableRow = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tr", {
        ref: ref,
        className: cn('border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted', className),
        ...props
    }));
TableRow.displayName = 'TableRow';
const TableHead = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("th", {
        ref: ref,
        className: cn('h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className),
        ...props
    }));
TableHead.displayName = 'TableHead';
const TableCell = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("td", {
        ref: ref,
        className: cn('p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className),
        ...props
    }));
TableCell.displayName = 'TableCell';
const TableCaption = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("caption", {
        ref: ref,
        className: cn('mt-4 text-sm text-muted-foreground', className),
        ...props
    }));
TableCaption.displayName = 'TableCaption';
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
